import { render, staticRenderFns } from "./RvGroup.vue?vue&type=template&id=3096f826&scoped=true"
import script from "./RvGroup.vue?vue&type=script&lang=js"
export * from "./RvGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096f826",
  null
  
)

export default component.exports